import React from 'react';
import { Form, Input, Row, Col, Select, Button} from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import ReactMarkdown from '../ReactMarkdown';
import '../../../survey-look/css/survey-look.css'
const FormItem = Form.Item;
const Option = Select.Option;

const SelectField = props => {
  const {
    choices,
    onAdd,
    onEdit,
    onDelete,
    margin = true,
    otherOption = false,
    onChangeSelect,
    newTab = false,
    offset,
    onSelectChange,
    onBlur,
    onSearch,
    disabled = false,
    selectedValue,
    coachingConversation,
    showSearch,
    loading,
    optionClassName,
    ...rest
  } = props;
  const [value, setValue] = React.useState('');
  const [visible, setVisible] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (ref && ref.current && ref.current.props && ref.current.props.value !== '') {
      setValue(ref.current.props.value);
    }
  }, []);

  const choice =
    choices &&
    choices.map((choice, key) => (
      <Option
        className={optionClassName}
        style ={{
          color: "#A3A3A3",
          fontSize: "1em",
          fontWeight: "500",
        }}
        key={key}
        value={String(choice?.value) === 'false' ? false : choice?.value === '' ? '' : choice?.value || choice?.label}
      >
        {typeof choice?.label === 'string' ? <ReactMarkdown>{choice?.label}</ReactMarkdown> : choice?.label}
      </Option>
    ));
  const otherField = (
    <Option key="other" value="">
      Other...
    </Option>
  );
  const handleChange = params => {
    if (params === '') {
      setVisible(true);
    } else {
      setVisible(false);
      onSelectChange && onSelectChange(params);
    }
  };
  const handleSelect = params => { 
    setValue(params);
    onChangeSelect && onChangeSelect(params);
  };

  const extraLinkProps = newTab
    ? {
        target: '_blank'
      }
    : {};

  return (
    <div style={{ marginBottom: margin ? '2vh' : '' }}>
      <Row gutter={[15, 5]}>
        <Col span={onAdd ? (onEdit ? 18 : 21) : 24}>
          <FormItem
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24, offset: margin && offset }}
            onChange={onSelectChange}
            {...rest}
          >
            <Select showSearch={showSearch} defaultValue={selectedValue}  onChange={handleChange} style={{textOverflow:"ellipsis",whiteSpace:"nowrap"}} {...props} ref={ref} onSelect={handleSelect} onSearch={onSearch} disabled={disabled}
             filterOption={(input,option)=> option} 
             >
              {otherOption ? (choices?.length > 0 ? [...choice, otherField] : [otherField]) : choice}
              {/* {choice} */}
            </Select>
          </FormItem>
        </Col>
        {onEdit && (
          <Col lg={2} md={3} style={{ paddingTop: '30px' }}>
            <Button shape="circle" disabled={!value} /* style={{ marginTop: '10px' }} */>
              <Link to={`${onEdit}${value}`}>
                <EditOutlined />
              </Link>
            </Button>
          </Col>
        )}
        {onAdd && (
          <Col lg={2} md={3} style={{ paddingTop: '30px' }}>
            <Button shape="circle" type="primary" ghost /* style={{ marginTop: '10px' }} */>
              <Link to={`/user/new`} {...extraLinkProps}>
                <PlusOutlined />
              </Link>
            </Button>
          </Col>
        )}
        {/* {onDelete && (
          <Col span={3} style={{ paddingTop: '3vh' }}>
            <DeleteIcon onClick={() => onDelete(value)} style={{ marginTop: '10px' }} />
          </Col>
        )} */}
      </Row>
      {visible && (
        <FormItem labelCol={{ span: 24 }} wrapperCol={{ span: 24, offset }} onChange={onSelectChange} {...rest} label={null}>
          <Input autoComplete='off' onBlur={onBlur} />
        </FormItem>
      )}
    </div>
  );
};

export default SelectField;